import { Button, Card, Col, Dropdown, Icon, Menu, Row, Spin, Table } from 'antd';
import React from 'react';
import strings from '../../eyeguide-localization/reports/string.table';
import Utils from '../common/utils';
import { BASELINETYPE } from '../common/constants';
import { Link } from 'react-router-dom';

interface ITableProps {
    // location: any;
    tests: Array<any>;
    pagination: any;
    sort: any;
    filter: any;
    rosterids: any;
    onPaginationChange: Function;
    loading: boolean;
    onPrint: any;
    onExport: any;
}

interface ITableState {
    columns: any;
    data: Array<any>;
}

class ReportsTable extends React.Component<ITableProps, ITableState> {
    menu = (
        <Menu onClick={(obj) => this.props.onExport(obj.key)}>
          <Menu.Item key="1">{strings.lsCSVDisplayedProfile}</Menu.Item>
          <Menu.Item key="2">{strings.lsCSVAllProfile}</Menu.Item>
        </Menu>
    );

    constructor(props: ITableProps) {
        super(props);
        this.state = {
            columns: this.buildColumns(),
            data: this.props.tests
        };
    }

    componentWillReceiveProps(nextprops: ITableProps) {
        var columns = this.buildColumns();
        this.setState({
            columns,
            data: nextprops.tests
        });
    }

    render() {
        var pagination = {
            ...this.props.pagination, 
            showSizeChanger: true,
            // showTotal: (total: any) => strings.formatString(strings.lsTotalTestTxt, total)
        };
        return (
            <Card title={strings.isReportsText}>                
                <Row 
                    hidden={!(this.props.tests && this.props.tests.length > 0)} 
                    type="flex"
                >
                   <Col className="tableCol">
                        <Row type="flex" justify="end">
                            <Button onClick={this.props.onPrint}>
                                {strings.lsPrintTxt}
                            </Button>
                            <Col>&nbsp;&nbsp;</Col>
                            <Dropdown 
                                trigger={['click']}
                                overlay={this.menu}
                                getPopupContainer={this.getContainer}
                            >
                                <Button className="downloadBtn"> 
                                    {strings.lsDwnldTxt} <Icon type="down" style={{ fontSize: 10}}/> 
                                </Button>
                            </Dropdown>
                        </Row>
                        <Row>&nbsp;</Row>
                        <Table 
                            className="ReportsTable"
                            columns={this.state.columns}
                            dataSource={this.buildData(this.state.data)}
                            pagination={pagination}
                            onChange={this.handleTableChange}
                            loading={this.props.loading}
                            scroll={{x: true}}
                        />
                        <Row>&nbsp;</Row>
                   </Col>
                </Row>
                <Row 
                    hidden={(this.props.tests && this.props.tests.length > 0 )} 
                    className="noData"
                >
                    No data
                    <Spin spinning={this.props.loading && this.props.tests.length === 0} />
                </Row>
            </Card>
        );
    }

    private buildColumns() {
        let columns = [
            {
                title: strings.isProfileName,
                dataIndex: 'profile',
                className: 'rows',
                fixed: 'left',
                sorter: true,
                width: 150
            },
            {
                title: strings.isDateTxt,
                dataIndex: 'datetime',
                className: 'rows',
                sorter: true,
                defaultSortOrder: 'ascend',
                width: 160
            },
            {
                title: strings.isTestTagTxt,
                dataIndex: 'testtag',
                className: 'rows',
                width: 140
            },
            {
                title: strings.isTypeTxt,
                dataIndex: 'testtype',
                className: 'rows',
                render: (text: any) => this.renderTestType(text),
                width: 140
            },
            {
                title: strings.isTestScore,
                dataIndex: 'score',
                className: 'rows',
                sorter: true,
                width: 100
            },
            {
                title: strings.isSubName,
                dataIndex: 'org_name',
                className: 'rows',
                sorter: true,
                width: 200
            },
            {
                title: strings.isSubCity,
                dataIndex: 'org_location',
                className: 'rows',
                width: 150
            },
            {
                title: strings.isSubEmail,
                dataIndex: 'org_email',
                className: 'rows',
                width: 200
            },
            {
                title: strings.isActionTxt,
                className: 'rows',
                width: 80,
                fixed: 'right',
                render: this.handleViewProfiles
            },
        ];
        return columns;
    }

    private handleViewProfiles = (row: any) => {
        var state = JSON.stringify({
            pagination: this.props.pagination,
            sort: this.props.sort,
            rosterids: this.props.rosterids,
            filter: this.props.filter
        });
        return (
            <Link 
                to={
                    {
                        pathname: '/profile/view/' + row.playerid,
                        state,
                    }
                } 
            >
                View
            </Link>
        );
    }

    private renderTestType = (text: any) => {
        return (
            <div style={{marginTop: 8}}>
                <div 
                    className={text === 'Baseline' ? 'bluedot' 
                             : text === 'Extremely Poor'
                                        || text === 'Very Poor'
                                        || text === 'Poor'
                                        ? 'reddot' : 'greendot'}
                />
                <div style={{ marginTop: -15, marginLeft: 10}}> {text} </div>
            </div>
        );
    }

    private buildData(tests: Array<any>) {
       
        let columnData: Array<any> = [];
        tests.forEach( (element: any) => {
            var playerinfo = element.athlete.playerinfo;
            let data: any = {
                testid: element.testid,
                playerid: element.playerid,
                profile: Utils.getProfileName(element.athlete, playerinfo),
                datetime: Utils.getDate(element.testtimestamp) + ' ' + Utils.getTime(element.testtimestamp),
                testtype: element.baseline === 1 ? BASELINETYPE.BASELINE : Utils.getLocalizedTestType(element.range),
                testtag: element.testtag + (element.bestbaseline === true && element.baseline === 1 ? ' (best)' : ''),
                concussed: Utils.getConcussed(element.concussed),
                score: Utils.formatNumber(element.score, 2),
                range: element.range,
                org_name: element.organization.name,
                org_location: this.renderCityState(element.organization),
                org_email: element.organization.contactemail,
                // admin: element.admin.firstname + ' ' + element.admin.lastname
            };
            if (element.testinfo) {
                data.eye = element.testinfo.length ? 'Left' : 'Right';
            }
            columnData.push(data);
        }); 
        return columnData;
    }

    private handleTableChange = (pagination: any, filter: any, sorter: any) => {
        this.props.onPaginationChange(pagination, sorter);
    }

    private renderCityState = ({city, state}) => [city, state].filter(e => e).join(', ');

    /**
     * Attatches dropdown lists to parent containers to avoid displacement during scroll
     */
    private getContainer = (triggernode: any) => {
        // debugger;
        return triggernode.parentNode;
    }
}

export default ReportsTable;


// WEBPACK FOOTER //
// ./src/components/reports/reports.table.tsx